import { render, staticRenderFns } from "./PrintTicketPresupuesto.vue?vue&type=template&id=105507ac&"
import script from "./PrintTicketPresupuesto.vue?vue&type=script&lang=js&"
export * from "./PrintTicketPresupuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports